import React from 'react';
import { IOption } from '../../../../models/product-detail';

interface OptionsSelectButtonProps {
    options: IOption[];
    label?: string;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    selectedOption: any;
    name: string;
    width?: string;
    isProductOptions: boolean;
}

const OptionsSelectButton = ({
    options,
    label,
    selectedOption,
    onChange,
    name,
    width,
    isProductOptions,
}: OptionsSelectButtonProps) => {
    return (
        <div>
            {label && (
                <div className="row">
                    <div className="col-md-12">
                        <h4>{label}</h4>
                    </div>
                </div>
            )}
            <div className="col-md-12">
                {options.map((option) => {
                    if (
                        !isProductOptions ||
                        (option.isAvailableLeft && option.isAvailableRight)
                    )
                        return (
                            <p
                                className="color-select"
                                key={option.name}
                                style={{
                                    marginRight: '10px',
                                    width: width ? width : '',
                                }}
                            >
                                <input
                                    type="radio"
                                    name={name}
                                    id={option.name}
                                    value={option.id}
                                    checked={selectedOption === option.id}
                                    onChange={onChange}
                                />
                                <label
                                    className="btn button-label no-text-transform"
                                    style={{
                                        border: '1px solid #1e9be9',
                                    }}
                                    htmlFor={option.name}
                                    dangerouslySetInnerHTML={{
                                        __html: option.name,
                                    }}
                                />
                            </p>
                        );
                })}
            </div>
        </div>
    );
};

export default OptionsSelectButton;
